import React from "react";
import "./biography.css";

/**
 * Biography Component - Life Story Section
 * 
 * Content from the memorial brochure for Mrs. Adriana Amy Danquah
 */
export default function Biography() {
    return (
        <section className="biography-section" id="biography">
            {/* Section Header - Wine banner style */}
            <header className="biography-header">
                <h2 className="biography-title">
                    <span className="title-script">Biography</span>
                    <span className="title-of">of</span>
                    <span className="title-name">Mrs Adriana Amy Danquah</span>
                </h2>
            </header>

            {/* Biography Content */}
            <div className="biography-content">
                {/* Scripture Quote */}
                <blockquote className="biography-scripture">
                    <p>"To live is Christ and to die is gain"</p>
                    <cite>— Philippians 1:21</cite>
                </blockquote>

                {/* Biography Text */}
                <div className="biography-text">
                    <p>
                        The life of Adriana EfuaAmy Danquah, affectionately known as Aunty Amy, is a vibrant
                        tapestry woven with threads of unwavering faith, selfless service, and a profound love for
                        Christ and humanity. Aunty Amy was born in Sekondi-Takoradi on 22nd-september, 1974
                        to Joseph V.C. Orleans and Victoria Annan. She joined her paternal family in Freetown as
                        a child when the family relocated to Sierra Leone. Her formative years were spent in Sierra
                        Leone, where she lived for nearly fifteen years. She was raised with a foundational
                        understanding that life's greatest value is found in what we give out rather than what we
                        accumulate. She lived most of her childhood life in Freetown-Sierra Leone with her
                        paternal family. Those who knew her early life remember a young woman who found her
                        greatest joy in helping others. This conviction took deep root at an early age when she
                        made the life-altering decision to follow Jesus Christ. From that moment forward, her
                        journey was no longer her own; it became a mission to reflect the light of the Gospel in
                        every corner of her world. Over the past fifty-one years, she moved through the seasons
                        of life, from a challenging childhood, through the energetic aspirations of youthfulness to
                        the seasoned wisdom of adulthood with a singular focus to be the hands and feet of the Lord Jesus to those in need.
                    </p>

                    <p>
                        In her youthful age, Adriana Amy Danquah sought to align her professional and personal
                        life with her spiritual convictions. Whether she was working with Consika Ltd and Danqsi
                        Ltd or raising her family, she viewed every environment as a mission field. She realized
                        early in life that to serve the Lord Jesus was to serve humanity, and so she began to view
                        every person she met as an image-bearer of the Creator. She did not just speak about
                        the love of Christ, she demonstrated it by mentoring young women and helping others.
                        Her involvement in Christ Apostolic Church International-CACI activities served as a
                        cornerstone of her life, where she led with a servant's heart and mentored the younger
                        generation of believers, teaching them that true leadership is rooted in humility. She was
                        often found preparing meals for the needy, organizing women's fellowship retreats, or
                        providing quiet counsel to the grieving. Those early years were defined by a yearning for
                        a greater purpose. The seeds of her future service were already being sown in her natural
                        empathy and her stand as a helping hand to others. In those early years, she learned the
                        value of hard work and the importance of family.
                    </p>

                    <p>
                        Aunty Amy's passion for building God's Kingdom was extraordinary. When the CACI New
                        Bortianor Local Assembly began in the year 2000, Aunty Amy made it a pledge to be
                        present at the Friday Morning Prayer Meetings continuously while still being fully
                        committed to fellowshipping at New Mamprobi Assembly. In 2009, Aunty Amy finally
                        joined Christ Apostolic Church International, New Bortianor Assembly, and instantly
                        became a strong pillar in the New Bortianor Assembly. As the Elder in charge of
                        Evangelism, she served with passion and grace. No distance was too far and no task too
                        burdensome. After every service, she ensured visitations were done via phone calls,
                        follow-ups, and personal visits using her own resources. Aunty Amy lived over 14km away
                        from the church, yet she always made it a responsibility to arrive early and serve
                        wholeheartedly. Aunty Amy's passion for GOD's work made her lead the then Missions
                        Director, Apostle Amaning (Rtd), Pastor Woode and other church leaders to establish
                        the Sierra Leone Branch of CACI, an achievement that continues to bear fruit. For Adriana
                        Amy Danquah, "To live is Christ and to die is gain" as the Apostle Paul submitted in
                        Philippians 1:21. To Aunty Amy, Christ Apostolic Church International was her family, her
                        home and her joy.
                    </p>

                    <p>
                        A defining chapter of Adriana Amy Danquah's story unfolded at the age of 25years, when
                        she entered into the sacred covenant of marriage with Kwame Danquah. This union was
                        far more than a social milestone. This union was the joining of two hearts under a shared
                        mission to serve the Lord Jesus. Adriana Amy Danquah entered into platonic relationship
                        with her future husband, Kwame Danquah in January 1999. Adriana Amy orleans as she
                        was called, got engaged to kwame Danquah on the I7th - July, 1999 at her paternal
                        residence at Kweikuma estate, Takoradi. Adriana Amy Orleans got married to Kwame
                        Danquah on 15th - August, 1999 at Christ Apostolic Church International - Mamprobi
                        branch. As she stood on the matrimonial altar, she committed not only to a partner but to
                        a lifetime of building a Christian home. Together, the couple navigated the early years of
                        adulthood, learning that the strength of a marriage is found in the three-fold cord of
                        husband, wife and God. This relationship became the bedrock from which her public
                        service grew, providing her with the support and love necessary to pour herself out for
                        others. Aunty Amy and the husband moved to an apartment at Darkuman junction after
                        marriage and started a family. The husband worked as the manager of a family business
                        construction firm, Bremak Ventures Ltd, and Aunty Amy worked as a clothing trader in
                        Accra. The couple had their first child, Efua Danquah in 2001. The second child, Yaw
                        Danquah was in 2004 and the last child, Kukua Danquah was born in 2009. Aunty Amy
                        taught her children the values of respect, hard work, and faith. People in need came to her
                        for assistance and comfort and she gave it freely without getting tired. Aunty Amy worked
                        hard and joined the husband as one of the directors in some companies and
                        organizations. After Aunty Amy received her Bachelor of Arts degree in communication
                        studies (development communication) from the African University College of
                        Communication in 2014, she pledged and committed her life to serving GOD in different
                        roles in Christ Apostolic Church International.
                    </p>

                    <p>
                        Adriana Amy Danquah worked as a director of Consika Ltd, a construction company, a
                        director of Dangsi Ltd,aninvestment management company and the Women Affairs
                        Director of the International Secretariat of Harakati Za Muungano, a Pan-African NGO.
                        Aunty Amy was a tireless advocate for workers welfare. She consistently stood for
                        improved salaries and better working conditions, ensuring that the well-being of working
                        staff was never overlooked. She carried the workers concerns as her own and spoke on
                        behalf of workers with courage, and love. Beyond advocacy, Aunty Amy assisted workers
                        with her own hands. Aunty Amy shared in the workers daily struggles by always availing
                        herself to assist when financial or work-related challenges arose. In her generosity, she
                        went even further, by purchasing essential items and offering them to staff on
                        interest-free credit, simply to ensure that everyone had what they needed to live with
                        dignity. Her approach transformed the companies into a family, not just a place of work.
                        Indeed, Aunty Amy was more than a director; she was a mother and a guardian for some
                        of the companies.
                    </p>

                    <p>
                        Adriana Amy Danquah's legacy will not be found in titles or accolades, but in the lives she
                        has touched, the mouths she has fed and the souls she has pointed toward the Cross. To
                        her husband, children and extended family, she was a source of constant encouragement,
                        a typical "Proverbs 31" woman in the flesh and a living example of the Fruit of the Spirit. To
                        her community, she was a helping hand and a peacemaker.
                        May the LORD JESUS grant you perfect peace and perfect rest i n heaven.
                        Your memory will forever remain a blessing.
                        Damirifa due.
                    </p>

                    <p className="biography-closing">
                        Rest well, Adriana Amy Danquah. My prayer is that your soul find perfect peace
                        and eternal rest in JESUS OUR LORD.
                    </p>

                    <p className="biography-signature">
                    </p>
                </div>
            </div>

            {/* Decorative Elements */}
            <div className="biography-decor biography-decor-flower" />

            {/* Footer
            <footer className="biography-footer">
                <div className="footer-line" />
                <p className="footer-text">In Loving Memory of the Late Mrs Adriana Amy Danquah</p>
                <div className="footer-dot" />
            </footer> */}
        </section>
    );
}
// TODO: Remmeber to add that flower at the corner backgroubnd